import * as React from "react";
import { Header } from "./header";
import "../css/style.css";
import { Footer } from "./footer";
export function Layout({ children }) {
    return (<div className="">
      <Header className="lg:fixed pin-t pin-l z-20 lg:rounded-br-lg"/>
      <div className="container mx-auto px-4 lg:px-32 pb-32 relative">
        {children}
      </div>
      <Footer />
    </div>);
}
export function LayoutIndex({ children }) {
    return (<div className="">
      <Header className="lg:fixed pin-t pin-l pin-r z-20" noMenu={true}/>
      <div className="container mx-auto px-4 lg:px-32 pb-32 pt-16 relative">
        {children}
      </div>
      <Footer />
    </div>);
}
//# sourceMappingURL=layout.jsx.map